import { render, staticRenderFns } from "./ProductZone.vue?vue&type=template&id=e93b684a&scoped=true"
import script from "./ProductZone.vue?vue&type=script&lang=js"
export * from "./ProductZone.vue?vue&type=script&lang=js"
import style0 from "./ProductZone.vue?vue&type=style&index=0&id=e93b684a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93b684a",
  null
  
)

export default component.exports